import { useEffect, useRef } from 'react';

const useFilterDismissal = (isOpen: boolean, onClose: () => void) => {
    const filterRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const filter = filterRef.current;
        if (!isOpen || !filter) return;
        let blurTimeout: number;

        const closeIfOutside = (event: Event) => {
            if (event.target instanceof Node && !filter.contains(event.target)) onClose();
        };
        const handleFocus = (event: FocusEvent) => {
            if (event.target instanceof Element && !filter.contains(event.target)) onClose();
        };
        const handleBlur = () => {
            // A label click can briefly blur the previous input before focusing its checkbox.
            window.clearTimeout(blurTimeout);
            blurTimeout = window.setTimeout(() => {
                if (!filter.contains(document.activeElement)) onClose();
            }, 0);
        };

        document.addEventListener('pointerdown', closeIfOutside);
        document.addEventListener('focusin', handleFocus);
        filter.addEventListener('focusout', handleBlur);
        window.addEventListener('blur', onClose);

        return () => {
            window.clearTimeout(blurTimeout);
            document.removeEventListener('pointerdown', closeIfOutside);
            document.removeEventListener('focusin', handleFocus);
            filter.removeEventListener('focusout', handleBlur);
            window.removeEventListener('blur', onClose);
        };
    }, [isOpen, onClose]);

    return filterRef;
};

export default useFilterDismissal;
